import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.initialize("G-RMVZH0JM2W");
    }, []);

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname,
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;